import React from 'react';
import { HoverBadges } from './HoverBadges';
import EditButton from 'components/v2/buttons/EditButton';
function ShipmentLegs({ value, node, column, api }) {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        api.startEditingCell({
            rowIndex: node.rowIndex,
            colKey: column.getId(),
        });
    };
    return (React.createElement("div", { className: "flex justify-between" },
        React.createElement(HoverBadges, { value: value }),
        React.createElement(EditButton, { className: "flex-shrink-0 flex-grow-0", size: "small", onClick: handleClick })));
}
export default ShipmentLegs;
